<template>
  <b-alert variant="warning" :show="true">
    {{ $t('Your profile is managed by our account management team.') }}
    <router-link :to="{name: 'contact'}">
      {{ $t('Please contact us for any changes.') }}
    </router-link>
  </b-alert>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>
